<template>
  <v-form v-model="valid" ref="form">
    <v-snackbar
      transition="slide-y-transition"
      v-model="alert"
      timeout="3000"
      top
      dark
      color="sokoDeep"
      >{{ alertMsg }}</v-snackbar
    >
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="First Name"
          name="firstname"
          required
          :rules="[validationRules.required, validationRules.name]"
          v-model="firstname"
          autocomplete="false"
          :disabled="!editProfile"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="Last Name"
          name="lastname"
          required
          :rules="[validationRules.name]"
          v-model="lastname"
          autocomplete="false"
          :disabled="!editProfile"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-row no-gutters>
          <v-col cols="4">
            <v-select
              v-model="zip"
              :items="countryCodes"
              menu-props="auto"
              label="Zip"
              :disabled="!editProfile"
            ></v-select>
            <!-- <v-text-field value="+233" :disabled="!editProfile"></v-text-field> -->
          </v-col>
          <v-col cols="7">
            <v-text-field
              label="Phone Number"
              name="phone"
              required
              :rules="[validationRules.phone]"
              v-model="phone"
              type="text"
              :disabled="!editProfile"
              :maxlength="10"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="Email"
          name="email"
          required
          :rules="[validationRules.email]"
          v-model="email"
          autocomplete="false"
          :disabled="!editProfile"
        ></v-text-field>
      </v-col>

      <template v-if="dialog">
        <!-- Action buttons -->
        <v-col cols="12" md="3">
          <v-btn
            rounded
            block
            outlined
            color="sokoDeep"
            :loading="loading"
            @click="updateProfile"
            >update</v-btn
          >
        </v-col>

        <v-col cols="12" md="3">
          <v-btn
            rounded
            block
            depressed
            class="sokoDeep white--text"
            :loading="loading"
            @click="updateProfile(true)"
            >update and continue</v-btn
          >
        </v-col>
      </template>
      <template v-else>
        <!-- Action buttons -->
        <v-col cols="12" md="3">
          <v-btn
            rounded
            block
            depressed
            dark
            @click="editProfile = !editProfile"
            :class="{
              'grey darken-3': editProfile,
              'grey darken-4': !editProfile,
            }"
            >{{ !editProfile ? "edit" : "done" }}</v-btn
          >
        </v-col>

        <v-col cols="12" md="3" v-if="editProfile">
          <v-btn
            rounded
            block
            depressed
            class="sokoDeep white--text"
            :loading="loading"
            @click="updateProfile"
            >update</v-btn
          >
        </v-col>
      </template>

      <!-- End action buttons -->
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import countryCodes from "@/externals/data/CountryCodes.js";
import validationRules from "@/externals/logic/ValidationRules.js";
import pnf from "@/externals/logic/PhoneNumberFormatter.js";

export default {
  name: "User",
  props: {
    // userDetails: {
    //   type: Object,
    //   required: true,
    // },
    dialog: {
      type: Boolean,
    },
  },

  data: () => ({
    // ui/ux variables
    alert: false, // alert diplay status
    alertMsg: "Failure!", // alert massage
    valid: false, // form validity
    editProfile: false, // user wants to edit the profile
    isSuccess: false, // updating profile was successful or not
    loading: false, // update btn is loading

    firstname: "", // firstname
    lastname: "", // lastname
    email: "", // email
    phone: "", // phone number
    zip: "+233",

    validationRules,
    countryCodes,
  }),

  mounted() {
    this.firstname = this.userDetails.fname || "";
    this.lastname = this.userDetails.lname || "";
    this.email = this.userDetails.email || "";
    this.editProfile = this.dialog;
    if (this.userDetails.phonenumber !== "") {
      const phoneNzip = pnf.destructure(this.userDetails.phonenumber);
      this.zip = phoneNzip[0];
      this.phone = phoneNzip[1];
      // console.log(this.zip);
      // console.log(this.phone);
      // console.log(pnf.structure(this.zip, this.phone));
    } else this.phone = "";
  },

  computed: {
    alertType() {
      // alert type error or success in this case
      return this.isSuccess ? "sokoDeep" : "error";
    },
    userDetails() {
      return this.$store.getters.getCollection("user");
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    async updateProfile(andContinue) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const data = {
          fname: this.firstname,
          lname: this.lastname,
          phonenumber: pnf.structure(this.zip, this.phone),
          email: this.email,
        };

        const response = await this.makeFetch({
          method: "patch",
          body: data,
          addUrl: "/update",
          withId: true,
          stateVar: "user",
        }).catch((err) => {
          console.log(err);
          this.alertMsg =
            "No connection was established to update your profile. Please try again later!";
          this.isSuccess = false;
          this.alert = true;
          this.loading = false;
          return;
        });

        this.isSuccess = response;

        this.alertMsg = this.isSuccess
          ? "Profile updated successfully"
          : "Could not update profile. Please try again later!";

        if (this.isSuccess && this.dialog) {
          this.$emit("profileUpdated", { andContinue: andContinue });
        }

        this.alert = true;
        this.loading = false;

        // dismiss alert after 3s
        // setTimeout(() => (this.alert = false), 10000);
      } else {
        this.alertMsg = "The form did not pass validation.";
        this.alert = true;
      }
    },
  },
};
</script>
